import React from 'react';
import CustomInput from 'Common/CustomInput';
import { PiWarningCircleLight } from "react-icons/pi";
import PasswordStrengthIndicator from 'Common/PasswordStrengthIndicator/PasswordStrengthIndicator';
import { BsCheck2Circle } from 'react-icons/bs';

const ResetPasswordStep2 = ({ newPassword, confirmPassword, onInputChange }) => (
  <div className="space-y-4">
    <div>
      <CustomInput
        value={newPassword}
        name="newPassword"
        label="New Password"
        toLower
        type="password"
        placeholder="Enter a new password"
        onChange={onInputChange}
      />
      <PasswordStrengthIndicator password={newPassword} />
    </div>
    <div className="w-full">
      <CustomInput
        value={confirmPassword}
        name="confirmPassword"
        label="Confirm New Password"
        toLower
        placeholder="Re-enter new password"
        type="password"
        onChange={onInputChange}
      />
      {confirmPassword && (
        <p className={`text-sm mt-1 ${newPassword === confirmPassword ? "text-green-600" : "text-red-600"}`}>
          {newPassword === confirmPassword ? <div className='flex gap-1 items-center'><BsCheck2Circle className="text-green-600" /><span>Passwords match</span></div> : <div className='flex gap-1 items-center'><PiWarningCircleLight /><span>Passwords don't match</span></div>}
        </p>
      )}
    </div>
  </div>
);

export default ResetPasswordStep2; 